var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.64 54.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9fa1a4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.38,30.18a1.5,1.5,0,0,0,1.51,1.5h9.66a.91.91,0,0,1,.82.53l2.76,5.89a.82.82,0,0,0,.69.52.78.78,0,0,0,.74-.31h0a.81.81,0,0,0,.09-.74L36.72,30.9a1.52,1.52,0,0,0-1.44-1H28.51a.9.9,0,0,1-.91-.9V27.46h-.3c-1.67,0-2.7-1.29-2.7-3.36V21.68a.91.91,0,0,1,1.81,0V24.1a1.41,1.41,0,0,0,1.48,1.55h4.85a.91.91,0,0,0,0-1.82H28.51a.9.9,0,0,1-.91-.9V21.29A2.24,2.24,0,0,0,25.71,19h-.23a2.09,2.09,0,0,0-1.41.55,2.12,2.12,0,0,0-.69,1.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.09,
    cy: 12.66,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.32,0A27.32,27.32,0,1,0,54.64,27.32,27.32,27.32,0,0,0,27.32,0ZM26.09,8.62a4,4,0,1,1-4,4A4.05,4.05,0,0,1,26.09,8.62ZM24.28,43.28a10.09,10.09,0,0,1-4.71-19,1.08,1.08,0,0,1,.79-.07,1,1,0,0,1,.6.5,1,1,0,0,1,.08.78,1,1,0,0,1-.51.61A8,8,0,1,0,32.15,34.8a1,1,0,0,1,2,.41A10.11,10.11,0,0,1,24.28,43.28Zm16.77-3.94a2.61,2.61,0,0,1-4.58-.52L34,33.5H24.89a3.33,3.33,0,0,1-3.33-3.32V21.12a3.93,3.93,0,0,1,4.33-3.91,4.05,4.05,0,0,1,3.52,4.08V22h3.33a2.72,2.72,0,0,1,0,5.44H29.41v.6h5.87a3.33,3.33,0,0,1,3.12,2.15l2.93,6.69A2.64,2.64,0,0,1,41.05,39.34Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisability);
export default __webpack_public_path__ + "static/media/disability.b32093639fbde54d7d846c9e1e5e53a0.svg";
export { ForwardRef as ReactComponent };